import {
	RequirementDetailsQuery,
	RequirementDetailsQueryVariables,
} from '../hooks/requirementDetails.generated';
import {QueryResult} from '@apollo/client';

export type RequirementFromDetailsPage = NonNullable<
	RequirementDetailsQuery['requirement']
>;

export type RequirementDetailsResult = QueryResult<
	RequirementDetailsQuery,
	RequirementDetailsQueryVariables
>;

export enum RequirementStatusType {
	None,
	Draft,
	SendToApproval,
	CompleteWithoutApproval,
	ClearingOK,
	ClearingNOK,
	ReadyToConfirm,
}
